/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Phgraph = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_phgraph',
		size: 'big',
		type: 'normal'
	},

	initialize: function(_element, options){
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls + ' .graph');

		if(this._element)
			this.build();
	},

	build: function(){
		var self = this;
		var opts = this.options;
		var current_date = new Date();

		self.values = [];
		self.labels = [];
		self.values1 = [];

		// this.first_is_max = true;

		if(opts.data && opts.data != ''){
			self.data = [];
			var first_history_date;

			opts.data.each(function(e, i){
				var price = (e.price).toInt();
				//NCR-2661, use the graph with date range if the data is more than 5
				if (opts.data.length <= 5 || opts.size == 'small') {
					self.values.push(price);
				} else {
					self.values.push([new Date(e.date).getTime(), e.price.toInt(), i]);
				}

				if(i == 0){
					first_history_date = new Date(e.date);
				}

				// NCR-654, display month and year if first date is not in current year.
				if(first_history_date.getFullYear() < current_date.getFullYear()){
					var date = new Date(e.date);
					var year = date.getFullYear().toString().substr(2,2);
					var month = e.short_date.substr(0, e.short_date.indexOf(' '));

					self.labels.push(month + ' ' + year);
				}
				else{
					self.labels.push(e.short_date);
				}

				self.data[i] = [];
				self.data[i][0] = e.price;
				self.data[i][1] = e.date;
				self.data[i][2] = '';
				self.data[i][3] = (e.cumulative.toFloat() != 0)? e.cumulative.toFloat(1) : '0.0';
				self.data[i][4] = e.difference;
				self.data[i][5] = e.change;

				// if(self.data[i][0] > self.data[0][0]){
				//	 self.first_is_max = false;
				// }
			});

			self.in_listing = true;

			if (opts.data.length <= 5 || opts.size == 'small') {
				self.draw_graph();
			} else {
				self._element.addClass('_with_date_range');
				self.draw_graph_with_daterange();
			}
		}else{
			var _data = this._element.getElement('.data');
			if(_data){
				self.data = _data.get('text').trim().split(';');
				_data.dispose();

				self.data.each(function(e, i){
					self.data[i] = e.split('|');
					self.data[i][0] = self.data[i][0].toInt();// console.log(self.data[i][0], self.data[0][0]);
					self.values.push(self.data[i][0]);
					self.labels.push(self.data[i][2]);

					// if(self.data[i][0] > self.data[0][0]){
					//	 self.first_is_max = false;
					// }
				});

				self.draw_graph();
			}
		}
	},

	draw_graph_with_daterange: function() {
		var self = this;
		var bkg = (self.in_listing) ? '#f0f0f0' : '#666666';
		var xLabelColor = (self.in_listing) ? '#888' : '#fff';
		var xLineColor = (self.in_listing) ? '#777' : '#ccc';
		if (this.options.type === 'verylightgrey') {
			bkg = '#f5f5f5';
			xLabelColor = '#000';
			xLineColor = '#000';
		}

		this.move_rangeselector();

		this.chart = new Highcharts.Chart({
			chart: {
				renderTo: this._element,
				type: 'line',
				marginTop: 25,
				marginBottom: self.options.size == 'big'? 20 : 0,
				backgroundColor: bkg,
				padding: 20,
				events: {
					load: function(event) {
						if (this.rangeSelector) {
							this.rangeSelector.clickButton(0, this.rangeSelector.buttonOptions[0], true);
						}
					}
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				enabled: true,
				selected: 1,
				allButtonsEnabled: true,
				inputEnabled: false,
				labelStyle: {
					color: '#666'
				},
				buttons: [{
					type: 'week',
					count: 1,
					text: '1w'
				}, {
					type: 'week',
					count: 2,
					text: '2w'
				}, {
					type: 'month',
					count: 1,
					text: '1m'
				}, {
					type: 'month',
					count: 3,
					text: '3m'
				}, {
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'all',
					text: 'All'
				}],
				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				}
			},

			navigator: {
				enabled: true,
				height: 15,
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			},

			series: [{
				type: 'line',
				color: '#73d1f6',
				lineWidth: 4,
				data: self.values
			}],

			legend: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				ordinal: false,
				title: {
					text: null
				},
				labels: {
					format: '{value:%b %d}',
					style: {
						color: xLabelColor,
						textTransform: 'uppercase'
					}
				},
				tickLength: 0,
				startOnTick: false,
				lineColor: xLineColor
			},

			yAxis: {
				title: {
					text: null
				},
				labels: {
					formatter: function() {
						return '$' + Core.add_commas(this.value);
					}
				}
			},

			plotOptions: {
				series: {
					marker: {
						radius: 6,
						states: {
							hover: {
								fillColor: '#008c99',
								lineWidth: 3
							}
						}
					},
					point:{
						events:{
							mouseOver: function(e){
								var i = this.series.data.indexOf(e.target);

								if (!self._parent) {
									self._parent = self._element.getParent('.w_pricehistory') || self._element.getParent();
									self._pricehistory_table_trs = self._parent.getElements('.w_pricehistory_table tbody tr') || [];
								}

								if (self._parent && self._pricehistory_table_trs[i]) {
									self._pricehistory_table_trs[i].addClass('_active');
								}
							},
							mouseOut: function(e) {
								var i = this.series.data.indexOf(e.target);

								if (self._pricehistory_table_trs[i]) {
									self._pricehistory_table_trs[i].removeClass('_active');
								}
							}
						}
					},
					dataLabels:{
						style: {
							textShadow: 'none'
						 }
					},

					animation: true
				},

				line: {
					dataLabels: {
						enabled: true,
						align: (self.in_listing) ? 'left' : 'center',
						style: {
							color: (self.in_listing) ? '#555' : '#fff',
							fontSize: Core.is_ie9() ? '13px' : '14px'
						},
						y: Core.is_ie9() ? 11 : -5,
						x: (self.in_listing) ? -20 : 0,
						formatter: function(e){
							if(self.in_listing){
								if(!self.one_label){
									self.one_label = true;
									return '$' + Core.add_commas(this.y);
								}
							}else{
								return '$' + Core.add_commas(this.y);
							}
						} 
					}, 

					// dataGrouping: {
					// 	dateTimeLabelFormats: {
					// 		day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
					// 		week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
					// 	}
					// },

					scrollbar: {
						barBackgroundColor: '#008C99',
						rifleColor: '#fff',
						buttonBackgroundColor: '#008C99',
						buttonArrowColor: '#fff'
					}
				}
			},

			tooltip: {
				enabled: self.options.size == 'big',
				useHTML: true,
				shared: (Core.is_ie8()) ? true : false,
				formatter: function(){
					var point = this.point;
					var i = this.series.data.indexOf(point);
					var point_data = self.data[i];

					var add_class = (point_data[3].toFloat() != 0) ?
													((point_data[3].toFloat() > 0) ? ' pos' : ' neg') : '';

					var sign = (point_data[3].toFloat() > 0) ? '+' : '';
					var content;
					if(self.in_listing){
						content =
						'<div class="bulb">' +
							'<span class="date">' + point_data[1] + '</span>' +
							'<span class="big">$' + Highcharts.numberFormat(point_data[0], 0) + '</span>' +
							point_data[4] +
							((point_data[5] != 0)?
								(' (' + ((point_data[5] > 0)? '+' : '')	+ point_data[5] + '%)<br/>Cumulative change: ' + ' <span class="msg bold' + add_class + '">' + sign + point_data[3] + '%</span>') :
								'<br/>') +
						'</div>';
					}else{
						if(i < self.data.length - 1){
							content =
							'<div class="bulb _idx">' +
								'<span>' + self.labels[i] + ' Year Index Price Change</span>' +
								'<span class="date">since ' + point_data[1] + '</span>' +
								'<span class="big' + add_class + '">' + sign + point_data[3] + '<span class="percent">%</span></span>' +
							'</div>';
						}else{
							content =
							'<div class="bulb _idx">' +
								'<span>Current Index Price</span>' +
								'<span class="date">as of ' + point_data[1] + '</span>' +
							'</div>';
						}
					}

					return content;
				},
				borderWidth: 0,
				backgroundColor: '#000',
				borderRadius: 0,
				shadow: false,
				style: {
					top: '-50px',
					padding: '0px'
				}
			},
		});
	},

	draw_graph: function(){
		var self = this;
		var bkg = (self.in_listing)? '#f0f0f0' : '#666666';
		var xLabelColor = (self.in_listing) ? '#888' : '#fff';
		var xLineColor = (self.in_listing) ? '#777' : '#ccc';
		var xDataColor = (self.in_listing) ? '#555' : '#fff';
		var dataFontSize = Core.is_ie9() ? '13px' : '14px';
		if (this.options.type === 'verylightgrey') {
			bkg = '#f5f5f5';
			xLabelColor = '#000';
			xLineColor = '#000';
			xDataColor = '#000';
			dataFontSize = '20px';
		}
		var uri_obj =  new URI(location.href);
		var show_type = uri_obj.get('query').parseQueryString().show;

		new Highcharts.Chart({
			chart: {
				renderTo: this._element,
				type: 'line',
				marginRight: 0,
				marginLeft: 0,
				marginBottom: self.options.size == 'big'? 20 : 0,
				backgroundColor: bkg,
				events: {
					load: function(event) {
						// When is chart ready?
						self.set_styles(this);
					}
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			xAxis: {
				title: {
					text: null
				},
				labels: {
					style: {
						color: xLabelColor,
						textTransform: 'uppercase',
						fontSize: '12px'
					},
					useHTML: (self.in_listing) ? true : false,
					formatter: function() {
						return '<span style="white-space:nowrap;">' + this.value + '</span>';
					}
				},
				categories: self.labels,
				tickLength: 0,

				startOnTick: false,
				minPadding: 0.2,
				maxPadding: 0.2,
				lineColor: xLineColor
			},

			yAxis: {
				title: {
					text: null
				},

				labels: {
					enabled: false
				},

				gridLineWidth: 0,
				startOnTick: false,
				minPadding: 0.2,
				maxPadding: 0.1
			},

			legend: {
				enabled: false
			},

			plotOptions: {
				series: {
					marker: {
						radius: 6,
						states: {
							hover: {
								fillColor: '#008c99',
								lineWidth: 3
							}
						}
					},
					point:{
						events:{
							mouseOver: function(e){
								if(!self._parent){
									self._parent = self._element.getParent('.w_pricehistory') || self._element.getParent();
									self._pricehistory_table_trs = self._parent.getElements('.w_pricehistory_table tbody tr') || [];
									self.row_counts = self._pricehistory_table_trs.length? self._pricehistory_table_trs.length - 1 : 0;
								}

								if(self._parent && self._pricehistory_table_trs.length && self._pricehistory_table_trs[self.row_counts - this.x]) {
									self._pricehistory_table_trs[self.row_counts - this.x].addClass('_active');
								}
							},
							mouseOut: function() {
								if(self._pricehistory_table_trs.length && self._pricehistory_table_trs[self.row_counts - this.x]) {
									self._pricehistory_table_trs[self.row_counts - this.x].removeClass('_active');
								}
              }
						}
					},
					dataLabels:{
						style: {
							textShadow: 'none'
						 }
					},

					animation: true
				},

				line: {
					dataLabels: {
						enabled: true,
						align: (self.in_listing) ? 'left' : 'center',
						style: {
							color: xDataColor,
							fontSize: dataFontSize
						},
						y: Core.is_ie9() ? 11 : -5,
						x: (self.in_listing) ? -20 : 0,
						formatter: function(e){
							if(self.in_listing){
								if(!self.one_label){
									self.one_label = true;
									return '$' + Core.add_commas(this.y);
								}
							}else{
								return '$' + Core.add_commas(this.y);
							}
						}
					}
				}
			},

			tooltip: {
				enabled: self.options.size == 'big',
				useHTML: true,
				shared: (Core.is_ie8()) ? true: false,
				formatter: function(){
					var point = this.point;
					var i = point.x;
					var point_data = self.data[i];
					var add_class = (point_data[3].toFloat() != 0) ?
													((point_data[3].toFloat() > 0) ? ' pos' : ' neg') : '';

					var sign = (point_data[3].toFloat() > 0) ? '+' : '';
					var content;
					if(self.in_listing){
						content =
						'<div class="bulb">' +
							'<span class="date">' + point_data[1] + '</span>' +
							'<span class="big">$' + Highcharts.numberFormat(point_data[0], 0) + '</span>' +
							point_data[4] +
							((point_data[5] != 0)?
								(' (' + ((point_data[5] > 0)? '+' : '')	+ point_data[5] + '%)<br/>Cumulative change: ' + ' <span class="msg bold' + add_class + '">' + sign + point_data[3] + '%</span>') :
								'<br/>') +
						'</div>';
					}else{
						if(i < self.data.length - 1){
							content =
							'<div class="bulb _idx">' +
								'<span>since ' + point_data[2] + '</span>' +
								//'<span class="date">since ' + point_data[1] + '</span>' +
								'<span class="big' + add_class + '">' + sign + point_data[3] + '<span class="percent">%</span></span>' +
								'<span>avg ' + (show_type ? show_type : 'price/ft<sup>2<sup>') + '</span>' +
							'</div>';
						}else{
							content =
							'<div class="bulb _idx">' +
								'<span>Current</span>' +
								//'<span class="date">as of ' + point_data[1] + '</span>' +
								'<span>avg ' + (show_type ? show_type : 'price/ft<sup>2<sup>') + '</span>' +
							'</div>';
						}
					}

					return content;
				},
				borderWidth: 0,
				backgroundColor: 'transparent',
				borderRadius: 0,
				shadow: false,
				style: {
					top: '-50px',
					padding: '0px'
				}
			},

			series: [{
				name: '',
				data: self.values,
				color: '#73d1f6',
				lineWidth: 4
			}]
		});
	},

	set_styles: function(graph){
		graph.xAxis[0].axisLine.element.setProperty('stroke-dasharray', '3,3'); //make xAxis dashed
	},

	move_rangeselector: function(){
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = (function(func) {
				return function(){
					func.apply(this, arguments);
					var leftPosition = this.chart.plotLeft - 80,
							topPosition = this.chart.plotTop - 45,
							space = 2;

					this.zoomText.attr({
						x: leftPosition + 170,
						y: topPosition - 5
					});

					leftPosition +=	this.zoomText.getBBox().width + 180;

					for (var i = 0; i < this.buttons.length; i++) {
						this.buttons[i].attr({
							x: leftPosition,
							y: topPosition - 20
						});
						leftPosition += this.buttons[i].width + space;
					}
				}
		} (Highcharts.RangeSelector.prototype.render));
	}
});
